module.exports = "<!-- <div class=\"sidebar-footer\"></div> -->\r\n"